import { render } from "./SectionsDetailInfoTable.vue?vue&type=template&id=2f271a1a"
import script from "./SectionsDetailInfoTable.vue?vue&type=script&lang=js"
export * from "./SectionsDetailInfoTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__